import React from "react";
import "../styling/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebookF,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faStar } from "@fortawesome/free-solid-svg-icons";

import ScrollArrow from "./scroll-arrow";
import AccessibilityWidget from "./AccessibilityWidget/components/AccessibilityWidget";
import CookieNotice from "./cookie-notice";

export default function footer() {
  const currentYear = new Date().getFullYear();

  return (
    <div>
      <ScrollArrow />
      <AccessibilityWidget />
      <CookieNotice />
      <div className="background">
        <br />
        <div className="footer">
          <table style={{ width: "100%", textAlign: "start" }}>
            <tr>
              <td className="table-width-50">
                <div className="center">
                  <h2 className="main-topic">Follow BEIRA BRUSH</h2>
                </div>
              </td>
              <td style={{ width: "auto" }}>
                <div className="social-icon">
                  <center>
                    <a
                      aria-label="facebook"
                      href="https://m.facebook.com/bpplholdings/"
                      target="_blank"
                      className="social-media"
                    >
                      <FontAwesomeIcon icon={faFacebookF} />
                    </a>
                    <a
                      aria-label="instagram"
                      href="https://www.instagram.com/bpplholdings/?hl=en"
                      target="_blank"
                      className="social-media"
                    >
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                    <a
                      aria-label="linkedin"
                      href="https://www.linkedin.com/authwall?trk=gf&trkInfo=AQFGcQwq21BvpAAAAXmY6y1gdvrDUoWyCzvXrnET9CsIfUHGFqmU_d93GwB-KbWkRW1Sf39-1JgyVWtWfWmDNmf0hu_x-wkWCQGZQCLP5A-TJpYD_dOWpX8ZBhc_gciVBjz9HGs=&originalReferer=https://www.google.com/&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fbpplholdings"
                      className="social-media"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                    <a
                      aria-label="youtube"
                      href="https://www.youtube.com/channel/UCcDxAIkOrJj4vUwHLWjUJHA"
                      className="social-media"
                      target="_blank"
                    >
                      <FontAwesomeIcon icon={faYoutube} />
                    </a>
                    <a
                      aria-label="twitter"
                      href="https://mobile.twitter.com/bpplholdings?lang=en"
                      target="_blank"
                      className="social-media"
                    >
                      <FontAwesomeIcon icon={faTwitter} />
                    </a>
                    <a
                      aria-label="email"
                      href="mailto:info@beirabrush.com"
                      target="_blank"
                      className="social-media"
                    >
                      <FontAwesomeIcon icon={faEnvelope} />
                    </a>
                  </center>
                </div>
              </td>
            </tr>
          </table>

          <table style={{ width: "100%", marginTop: "70px" }}>
            <tr>
              <td className="table-width-33">
                <h2 className="main-topic2">Head Office</h2>

                <div className="horizontal-line"></div>

                <table
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    textAlign: "start",
                  }}
                >
                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a href="https://www.google.com/maps/dir/6.9271552,79.8621696/Eco+Spindles+head+office/@6.9234847,79.8570101,16z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3ae25967ac881241:0x5bfe7c134ff43796!2m2!1d79.8574137!2d6.9201024">
                          Beira Brush Private Limited
                        </a>
                      </h3>
                      <p className="footer-text4">
                        No. 278/4, Level 17, Access Towers, <br />
                        Union Place, <br />
                        Colombo 2, Sri Lanka
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom"></div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a className="remove-underline" href="tel:+94112307168">
                          Phone
                        </a>
                      </h3>
                      <p className="footer-text4">+94 11 2307168</p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a>Dubai Office</a>
                      </h3>
                      <p className="footer-text4">
                        BBL General Trading L.L.C <br />
                        Office MF 70, Nooraniah Building, <br />
                        Hor AI Anz, Dubai, U.A.E
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom"></div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a className="remove-underline" href="tel:+94766118638">
                          Phone
                        </a>
                      </h3>
                      <p className="footer-text4">+94 766 118 638</p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a
                          className="remove-underline"
                          href="mailto:info@beirabrush.com"
                        >
                          Email
                        </a>
                      </h3>
                      <p className="footer-text4">
                        More Info -{" "}
                        <a
                          className="remove-underline"
                          href="mailto:info@beirabrush.com"
                        >
                          info@beirabrush.com
                        </a>{" "}
                        <br />
                        Careers -{" "}
                        <a
                          className="remove-underline"
                          href="mailto:careers@beirabrush.com"
                        >
                          careers@beirabrush.com
                        </a>
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
              <td style={{ width: "40px" }}></td>
              <td className="table-width-33">
                <h2>Factories</h2>
                <div className="horizontal-line"></div>

                <table
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    textAlign: "start",
                  }}
                >
                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom">
                          <FontAwesomeIcon icon={faStar} />
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a href="https://www.google.com/maps/dir/6.9271552,79.8621696/ECO+sPINDLES+MAUGAMA/@6.8830283,79.8100748,11z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x3ae24c6f1857017b:0xe07aa1a40584e958!2m2!1d80.0399572!2d6.747481">
                          Wood, Brush and Mop Factories
                        </a>
                      </h3>
                      <p className="footer-text4">
                        No. 88, Ratnapura Road, Ingiriya, Sri Lanka
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>
                      <div className="footer-text3-star">
                        <div className="star-top-bottom"></div>
                      </div>
                    </td>
                    <td style={{ width: "auto", verticalAlign: "top" }}>
                      <h3 className="footer-text3">
                        <a href="tel:+94342269908">Phone</a>
                      </h3>
                      <p className="footer-text4">+94 34 2269908</p>
                    </td>
                  </tr>
                </table>
              </td>
              <td style={{ width: "20px" }}></td>
              <td
                style={{
                  width: "auto",
                  verticalAlign: "top",
                }}
              >
                <h2>Quick Links</h2>
                <div className="horizontal-line"></div>

                <table
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    textAlign: "start",
                  }}
                >
                  <tr>
                    <div className="footer-text-icon">
                      <a href="/">
                        <span>
                          {/* <FontAwesomeIcon icon={faCheck} /> */}
                          <div className="footer-text-with-icon">Home</div>
                        </span>
                      </a>
                    </div>
                  </tr>

                  <tr>
                    <div className="footer-text-icon">
                      <a href="/company/">
                        <span>
                          {/* <FontAwesomeIcon icon={faXmark} /> */}
                          <div className="footer-text-with-icon">Company</div>
                        </span>
                      </a>
                    </div>
                  </tr>

                  <tr>
                    <div className="footer-text-icon">
                      <a href="/quality/">
                        <span style={{ fontSize: "17px" }}>
                          {/* &#10687; */}
                          <div className="footer-text-with-icon">Quality</div>
                        </span>
                      </a>
                    </div>
                  </tr>

                  <tr>
                    <div className="footer-text-icon">
                      <a href="/sustainability/">
                        <span>
                          {/* <FontAwesomeIcon icon={faCheck} /> */}
                          <div className="footer-text-with-icon">
                            Sustainability
                          </div>
                        </span>
                      </a>
                    </div>
                  </tr>

                  <tr>
                    <div className="footer-text-icon">
                      <a href="/store/">
                        <span>
                          {/* <FontAwesomeIcon icon={faCheck} /> */}
                          <div className="footer-text-with-icon">
                            Product Range
                          </div>
                        </span>
                      </a>
                    </div>
                  </tr>

                  <tr>
                    <div className="footer-text-icon">
                      <a href="/factories/">
                        <span>
                          {/* <FontAwesomeIcon icon={faCheck} /> */}
                          <div className="footer-text-with-icon">Factories</div>
                        </span>
                      </a>
                    </div>
                  </tr>

                  <tr>
                    <div className="footer-text-icon">
                      <a href="/contact-us/">
                        <span>
                          {/* <FontAwesomeIcon icon={faCheck} /> */}
                          <div className="footer-text-with-icon">Contact</div>
                        </span>
                      </a>
                    </div>
                  </tr>
                </table>
                {/* <div
                  className="footer-tw-bw-container"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: "30px",
                  }}
                >
                  <a href="https://topweb.lk/may2024/beirabrush">
                    <img
                      src="https://beirabrush-2024.sgp1.digitaloceanspaces.com/cdn.beirabrush.com-uploads/footer_tw_450_white_logo.webp"
                      alt="tw-logo"
                      width="auto"
                      height="120"
                    />
                  </a>

                  <a href="https://www.vote.bestweb.lk/site/www_beirabrush_lk/">
                    <img
                      className="footer-bw-logo"
                      src="https://beirabrush-2024.sgp1.digitaloceanspaces.com/logos/bestweb-24-vote4us.webp"
                      alt="bw-logo"
                      width="auto"
                      height="120"
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                    />
                  </a>
                </div> */}
              </td>
            </tr>
          </table>
          <br />
        </div>
      </div>

      <div className="black-footer">
        <br />
        <div className="footer-screen-pc">
          <div className="footer-black">
            {/* new part */}
            <div className="footer-new-container">
              {/* Column 1 */}
              <div className="footer-new-column">
                <div className="footer-bottom-25px">
                  <div className="footer-text2-start">
                    <div className="footer-text2">
                      Copyright &copy; {currentYear} Beira Brush
                    </div>
                  </div>
                </div>
              </div>
              {/* Column 2 */}
              <div className="footer-new-column">
                <div className="footer-bottom-25px">
                  <div className="footer-text2-end">
                    <a style={{ marginRight: "20px" }}>
                      <img
                        src="/images/Silver-Best-Manufacturing-&-Industrial-Website.png"
                        alt="tw-logo"
                        width="auto"
                        height="120px"
                        style={{ borderRadius: "5%" }}
                      />
                    </a>
                    <a href="https://topweb.lk/may2024/beirabrush">
                      <img
                        src="https://beirabrush-2024.sgp1.digitaloceanspaces.com/cdn.beirabrush.com-uploads/footer_tw_450_white_logo.webp"
                        alt="tw-logo"
                        width="auto"
                        height="100px"
                        style={{ borderRadius: "5%" }}
                      />
                    </a>
                  </div>
                </div>
              </div>
              {/* Column 3 */}
              <div className="footer-new-column">
                <div className="footer-top-25px">
                  <div className="footer-text2-end">
                    <div className="footer-text2">
                      <a className="footer-text2" href="/cookie-policy/">
                        Cookie Policy
                      </a>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <a className="footer-text2" href="/privacy-policy/">
                        Privacy Policy
                      </a>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <a className="footer-text2" href="/sitemap/">
                        Sitemap
                      </a>
                    </div>
                  </div>
                </div>
                <div className="footer-bottom-25px">
                  <div className="footer-text2-end">
                    <div className="footer-text2">
                      <a className="footer-text2" href="https://www.3cs.lk/">
                        Web Design by 3CS
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-screen-mobile">
          <div className="footer-black">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <div className="footer-bottom-25px">
                      <div className="footer-text2-start">
                        <p className="footer-text2">
                          Copyright &copy; {currentYear} Beira Brush
                        </p>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "auto" }}>
                    <div className="footer-bottom-25px">
                      <div className="footer-text2-end">
                        <p className="footer-text2">
                          <a
                            className="footer-text2"
                            href="https://www.3cs.lk/"
                          >
                            Web Design by 3CS
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="footer-bottom-25px">
                      <div className="footer-text2-end">
                        <p className="footer-text2">
                          <a className="footer-text2" href="/cookie-policy/">
                            Cookie Policy
                          </a>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <a className="footer-text2" href="/privacy-policy/">
                            Privacy Policy
                          </a>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <a className="footer-text2" href="/sitemap/">
                            Sitemap
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="footer-bottom-25px">
              <div className="footer-text2-end">
                <a href="https://topweb.lk/may2024/beirabrush">
                  <img
                    src="https://beirabrush-2024.sgp1.digitaloceanspaces.com/cdn.beirabrush.com-uploads/footer_tw_450_white_logo.webp"
                    alt="tw-logo"
                    width="auto"
                    height="100"
                    style={{ marginBottom: "40px", borderRadius: "5%" }}
                  />
                </a>
              </div>
              <div className="footer-text2-end">
                <div>
                  <img
                    src="/images/Silver-Best-Manufacturing-&-Industrial-Website.png"
                    alt="tw-logo"
                    width="auto"
                    height="150"
                    style={{ marginBottom: "40px", borderRadius: "5%" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
